import { useEffect, useState } from "react";
import axios from "axios";
import { appUrl } from "../../../../../../utils/config";
import { useApiBaseUrl } from "../../CommonMethods/CommonMethods";

// A CMO's own config (viewCMODetails / vendorProductTypeConfigs, erpConfigurations)
// only carries productTypeID — no name. This fetches the org-wide Product Type
// master list once and returns a { [productTypeID]: productTypeName } map so
// callers can resolve those IDs to display names.
export default function useProductTypeNames() {
  const API_BASE_URL = useApiBaseUrl(appUrl);
  const [namesById, setNamesById] = useState({});

  useEffect(() => {
    if (!API_BASE_URL) return;
    let isMounted = true;

    axios
      .get(`${API_BASE_URL}/fetchProductTypes/true`)
      .then((response) => {
        if (!isMounted) return;
        const list = response?.data?.data?.productTypeList || [];
        const map = {};
        list.forEach((item) => {
          map[item.productTypeID] = item.productTypeName;
        });
        setNamesById(map);
      })
      .catch((err) => {
        console.error("Error fetching product type names:", err);
      });

    return () => {
      isMounted = false;
    };
  }, [API_BASE_URL]);

  return namesById;
}
